<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <div class="div_loading">
            <div class="my-container" [hidden]="!loading">
                <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
            </div>
        </div>
        <span>
            <span>{{ title }}</span>
        </span>
        <span (click)="close()">
            <mat-icon class="close">close</mat-icon>
        </span>
    </div>
</div>


<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="cate" class='wh-label'>
                    <span *ngIf="lang == 1"> دسته : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <span (click)="reset_input(226,'')">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="cate_title" (click)="load_services(226,'')"
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="cate" [hidden]="true" [required]="required()" readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> عنوان : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <input class='wh-input' formControlName="title" autocomplete="off" [required]="required()">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="titleen" class='wh-label'>
                    <span *ngIf="lang == 1"> عنوان انگلیسی : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <input class='wh-input' formControlName="titleen" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="titlear" class='wh-label'>
                    <span *ngIf="lang == 1"> عنوان عربی : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <input class='wh-input' formControlName="titlear" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="titleru" class='wh-label'>
                    <span *ngIf="lang == 1"> عنوان روسی : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <input class='wh-input' formControlName="titleru" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="code" class='wh-label'>
                    <span *ngIf="lang == 1"> کد : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <input class='wh-input' formControlName="code" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="keywords" class='wh-label'>
                    <span *ngIf="lang == 1"> کلمات کلیدی : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <input class='wh-input' formControlName="keywords" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="type_task == 3">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> ترتیب : </span>
                    <span *ngIf="lang == 2"> Sort : </span>
                    <input class='wh-input' formControlName="sort" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعیت نمایش فارسی : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <span (click)="reset_input(221,1)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="status_title" (click)="load_services(221,1)"
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="status_id" [hidden]="true" [required]="required()"
                        readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعیت نمایش انگلیسی : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <span (click)="reset_input(221,2)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="status_title_en" (click)="load_services(221,2)"
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="status_id_en" [hidden]="true" [required]="required()"
                        readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعیت نمایش عربی : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <span (click)="reset_input(221,3)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="status_title_ar" (click)="load_services(221,3)"
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="status_id_ar" [hidden]="true" [required]="required()"
                        readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعیت نمایش روسی : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <span (click)="reset_input(221,4)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="status_title_ru" (click)="load_services(221,4)"
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="status_id_ru" [hidden]="true" [required]="required()"
                        readonly>
                </label>
            </div>

            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> توضیحات فارسی :</span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <ejs-richtexteditor [toolbarSettings]='tools' [height]='300' style="direction: ltr !important;"
                        [insertImageSettings]='insertImageSettings' (imageSelected)="onselected($event)"
                        formControlName="comment">
                        <ng-template #valueTemplate>
                            sadasd
                        </ng-template>
                    </ejs-richtexteditor>
                </label>
            </div>

            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> توضیحات انگلیسی :</span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <ejs-richtexteditor [toolbarSettings]='tools' [height]='300' style="direction: ltr !important;"
                        [insertImageSettings]='insertImageSettings' (imageSelected)="onselected($event)"
                        formControlName="comment_en">
                        <ng-template #valueTemplate>
                            sadasd
                        </ng-template>
                    </ejs-richtexteditor>
                </label>
            </div>

            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> توضیحات عربی :</span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <ejs-richtexteditor [toolbarSettings]='tools' [height]='300' style="direction: ltr !important;"
                        [insertImageSettings]='insertImageSettings' (imageSelected)="onselected($event)"
                        formControlName="comment_ar">
                        <ng-template #valueTemplate>
                            sadasd
                        </ng-template>
                    </ejs-richtexteditor>
                </label>
            </div>

            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> توضیحات روسی :</span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <ejs-richtexteditor [toolbarSettings]='tools' [height]='300' style="direction: ltr !important;"
                        [insertImageSettings]='insertImageSettings' (imageSelected)="onselected($event)"
                        formControlName="comment_ru">
                        <ng-template #valueTemplate>
                            sadasd
                        </ng-template>
                    </ejs-richtexteditor>
                </label>
            </div>

        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <button type="submit" [disabled]="!form1_group.valid" class="btn_pe" [ngClass]="{btn_en:lang == 2}"
            *ngIf="type_task == 1 || type_task == 2">
            <span *ngIf="lang == 2">Save</span>
            <span *ngIf="lang == 1">ذخیره</span>
        </button>
        <button type="submit" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3">
            <span *ngIf="lang == 2">Search</span>
            <span *ngIf="lang == 1">جستجو</span>
        </button>
        <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3"
            (click)="check_access(type_task,2)">
            <span *ngIf="lang == 2">Excel</span>
            <span *ngIf="lang == 1">خروجی اکسل</span>
        </button>
    </div>
</form>